import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import {memo} from "react";

import {semanticColor, sizing} from "@khanacademy/wonder-blocks-tokens";
import {LabelMedium} from "@khanacademy/wonder-blocks-typography";
import {Toast} from "@khan/component-toast";

const SuccessToast = ({onClose}: {onClose: () => void}): React.ReactElement => {
    return (
        <Toast
            autoTimeout={1500}
            style={styles.toast}
            closeIconColor="transparent"
            onClose={onClose}
        >
            <LabelMedium>{t`Your changes have been saved.`}</LabelMedium>
        </Toast>
    );
};

const styles = StyleSheet.create({
    toast: {
        backgroundColor: semanticColor.status.success.background,
        borderRadius: sizing.size_080,
        padding: sizing.size_080,
        paddingInlineEnd: sizing.size_160,
        paddingInlineStart: sizing.size_160,
        position: "fixed",
        top: sizing.size_240,
        insetInlineStart: "50%",
        transform: "translateX(-50%)",
    },
});

export default memo(SuccessToast);
